export enum SubscriptionIncentive {
  OUT_OF_IMAGE = 'out-of-image',
  OUT_OF_IMAGE_ALERT = 'out-of-image-alert',
  HIGH_RESOLUTION = 'high-resolution',
  PROFILE_PREVIEW = 'profile-preview-subscribe',
  PROFILE_FULL = 'profile-full-subscribe',
  PROFILE_SUBSCRIPTION_TERMS_MORE = 'profile-subscription-terms-more',
}
